import { render, staticRenderFns } from "./ContentDialog.vue?vue&type=template&id=850aa894"
import script from "./ContentDialog.vue?vue&type=script&lang=ts"
export * from "./ContentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports